import { Role, RoleName } from '../../../entities/users/user';
export const getFilteredRoles = (roles: Role[]) => {
  return roles.filter(
    (role) => role.name !== RoleName.STANDARD_USER && role.name !== RoleName.PROCESSING_MACHINE,
  );
};
